import AboutPageShell from '@/components/landing/about-page-shell';

const baseUrl = import.meta.env.VITE_APP_URL ?? (typeof window !== 'undefined' ? window.location.origin : '');

export default function AboutSchoolSeal() {
    return (
        <AboutPageShell
            title="School Seal & Motto"
            description="Learn the meaning behind the Northeastern College seal and the message carried by its motto, Knowledge is Power."
        >
            <div className="bg-card border-border relative overflow-hidden rounded-2xl border p-8 shadow-sm md:p-12">
                <div className="mb-6 flex justify-center">
                    <div className="border-border flex h-24 w-24 items-center justify-center overflow-hidden rounded-full border bg-white shadow-lg sm:h-28 sm:w-28 md:h-32 md:w-32">
                        <img src={`${baseUrl}/images/logo.webp`} alt="School Seal" className="h-[80%] w-[80%] rounded-full object-contain" />
                    </div>
                </div>

                <div className="mb-8 text-center">
                    <h2 className="text-foreground mb-2 text-2xl font-bold">School Seal &amp; Motto</h2>
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-[#0A7A35]/10 px-4 py-1.5 text-sm font-bold tracking-wide text-[#0A7A35] uppercase">
                        
                        &quot;Knowledge is Power&quot;
                    </span>
                </div>

                <div className="via-border mx-auto mb-8 h-px max-w-3xl bg-gradient-to-r from-transparent to-transparent" />

                <div className="text-muted-foreground mx-auto max-w-3xl space-y-5 text-center text-sm leading-relaxed md:text-left md:text-base">
                    <p>
                        The motto &quot;Knowledge is Power&quot; inscribed in the school seal signifies the greatest creative force that moves people
                        who are &quot;knowledge-thirst.&quot; The emblem symbolizes the vision that education is reflected in the way of living it
                        shapes and the people who embody that way of life.
                    </p>
                    <p>
                        The torch represents the new world of tomorrow, shaping and creating anew through centuries those who have faith and abilities
                        to uplift themselves and their fellows. The book provides wisdom to appreciate the beauty of reaching for one&apos;s star, the
                        skills and fortitude to climb the ladder.
                    </p>
                    <p>
                        For knowledge has been the greatest creative force in all history, broadening humanity&apos;s physical world, and strengthening
                        spiritual, mental, emotional intelligence, and social inclinations, making people the supreme creation of the Infinite Source.
                    </p>
                </div>
            </div>
        </AboutPageShell>
    );
}
